import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = {
  key: 0,
  class: "py-2"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "children-table" }
const _hoisted_5 = { class: "children-table__headers" }
const _hoisted_6 = { class: "children-table__header col-name" }
const _hoisted_7 = { class: "children-table__header col-height" }
const _hoisted_8 = { class: "children-table__header col-weight" }
const _hoisted_9 = { class: "children-table__header col-other" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_month_pager = _resolveComponent("month-pager")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_class_growth_record_row = _resolveComponent("class-growth-record-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: 'Growth Record List', href: '/growth-record', color: 'primary' },
          { title: `${_ctx.className} Growth Record` },
        ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, {
      value: `${_ctx.className} ${_ctx.$t('growthRecord.title')}`
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_month_pager, {
        modelValue: _ctx.yearMonth,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearMonth) = $event)),
        onInput: _ctx.pageClick
      }, null, 8, ["modelValue", "onInput"])
    ]),
    (_ctx.recordRequests.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            disabled: _ctx.isSaving,
            onClick: _ctx.saveRecords
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common_actions.save')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSaving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_linear, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('growthRecord.childName')), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('growthRecord.height')), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('growthRecord.weight')), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('growthRecord.remarks')), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (r) => {
        return (_openBlock(), _createBlock(_component_class_growth_record_row, {
          key: r.child.childId,
          record: r,
          onInputHeight: ($event: any) => (_ctx.inputHeight($event, r)),
          onInputWeight: ($event: any) => (_ctx.inputWeight($event, r)),
          onInputRemarks: ($event: any) => (_ctx.inputRemarks($event, r))
        }, null, 8, ["record", "onInputHeight", "onInputWeight", "onInputRemarks"]))
      }), 128))
    ])
  ]))
}